import React, { useEffect, useRef, useState } from "react";
import sidebarData from "./sidebar/sidebarData";
import "../App.css";
import NavItem from "./NavItem";
import useUserCompany from "../hooks/useUserCompany";
import Modal from "./Modal";
import UserCompany from "./user/UserCompany";
import { FaRegBuilding } from "react-icons/fa";
import { GoArrowSwitch } from "react-icons/go";

const Nav = ({ onNavItemClick, selectedCategory, openSidebar }) => {
  const navItems = Object.keys(sidebarData);
  const currentCompany = useUserCompany();
  const modalRef = useRef(null);
  const openModal = () => {
    modalRef.current?.showModal();
  };
  const [isOpen, setIsOpen] = useState(false);

  const handleItemClick = (item) => {
    setIsOpen(false);
    onNavItemClick(item);
    openSidebar();
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    // Update window width when the component mounts
    const handleResize = () => setWindowWidth(window.innerWidth);

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Remove event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <div className="nav-a">
        <nav className="navbar">
          <ul style={{ display: windowWidth <= 645 ? "none" : "flex" }}>
            {navItems.map((item, index) => (
              <NavItem
                key={index}
                item={item}
                handleItemClick={handleItemClick}
                selectedCategory={selectedCategory}
              />
            ))}
          </ul>
          <div
            className={`dropdown ${isOpen ? "open" : ""}`}
            style={{ display: windowWidth <= 645 ? "block" : "none" }}
          >
            <div className="dropdown-header" onClick={toggleDropdown}>
              <span>{selectedCategory}</span>
              <div className={`arrow ${isOpen ? "open" : ""}`}>&#9660;</div>
            </div>
            {isOpen && (
              <ul className="dropdown-list">
                {navItems.map((item) => (
                  <li key={item} onClick={() => handleItemClick(item)}>
                    {item}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </nav>
        <div className="company-switcher">
          <div style={{ display: "flex", gap: "10px" }}>
            {/* <FaRegBuilding size={20} /> */}
            <h4>
              {currentCompany ? currentCompany.comCompany : "Invalid Company"}
            </h4>
          </div>
          <div className="user-company" onClick={openModal}>
            <GoArrowSwitch size={22} />
          </div>
        </div>
      </div>
      <Modal ref={modalRef} minWidth={"300px"} minHeight={"200px"}>
        <UserCompany
          closeModal={() => {
            modalRef.current?.close();
            window.location.reload();
          }}
        />
      </Modal>
    </>
  );
};

export default Nav;
